import { Canvas } from '@react-three/fiber';
import { Bounds, Center } from '@react-three/drei';
import { Model } from './klein';

export function CanvasBG() {
  return (
    <div className="klein-slot" aria-label="Animated Klein bottle" role="img">
      <div className="klein-canvas">
        <Canvas camera={{ fov: 45, position: [0, 0, 50] }}>
          <ambientLight intensity={Math.PI / 2} />
          <Bounds fit clip observe margin={1.4}>
            <Center>
              <Model />
            </Center>
          </Bounds>
        </Canvas>
      </div>
    </div>
  );
}
